import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
  compactFormControl: {
    margin: theme.spacing(0.5),
    minWidth: 180,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function SimpleSelect({ value, setValue, label, options = [], allowNone = true, compact = false }) {
  const classes = useStyles();

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
      <FormControl variant="outlined" className={compact ? classes.compactFormControl : classes.formControl} size={compact ? 'small' : 'medium'}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={value ?? ''}
          onChange={handleChange}
          label={label}
          autoWidth
        >
          {allowNone && (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}
          {options.map((item) => (
            <MenuItem key={item.label} value={item.value}>{item.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
  );
}
